import script from "./IngresoPersona.vue?vue&type=script&setup=true&lang=js"
export * from "./IngresoPersona.vue?vue&type=script&setup=true&lang=js"

import "./IngresoPersona.vue?vue&type=style&index=0&id=02df7c26&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02df7c26"]])

export default __exports__